import React, { Component, useState, useEffect } from 'react';
import { Trans, Translation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { mapStateToProps } from 'root/redux/selector/selector';
import { withRouter } from 'react-router-dom';
import FlagsSelect from 'root/pages/05Registration/052_Flag_Select';
import SVGElements from 'root/components/SVGElements';
import notification from 'root/utils/notification';

const UploadImage = ({ children, onChange, value, accept, ...rest }) => {
    /**
     * @param {[File, React.SetStateAction<File>]}
     */
    const [fileData, setFileData] = useState();
    const [imagePath, setImagePath] = useState(value);
    const [acceptType, setAcceptType] = useState('image/*,.pdf');

    useEffect(() => {
        if (accept?.length) {
            const acceptType = [];
            for (let i = 0; i < accept.length; i++) {
                acceptType.push(`.${accept[i]}`);
            }
            setAcceptType(acceptType.join(','));
        }
    }, [accept]);

    /**
     * @param {React.ChangeEvent<HTMLInputElement>} event
     */
    const _onChange = (event) => {
        const files = event.target.files;

        if (!files.length) return;

        let fileData = null;
        let imagePath = null;

        if (!accept?.length || accept.some((type) => files[0].type.includes(type))) {
            fileData = files[0];
            imagePath = URL.createObjectURL(files[0]);
        }

        setFileData(fileData);
        setImagePath(imagePath);
        onChange(event);
    };

    return (
        <div
            style={{
                position: 'relative',
            }}
            {...rest}
        >
            <input
                type='file'
                accept={acceptType}
                style={{
                    position: 'absolute',
                    opacity: 0,
                    width: '100%',
                    height: '100%',
                    cursor: 'pointer',
                    zIndex: 2,
                }}
                onChange={_onChange}
            />
            {children(fileData, imagePath)}
        </div>
    );
};

class FormPopUp extends Component {
    isMount = true;
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            phone: '',
            address: '',
            remark: '',
            shippingAddress: '',
            betID: '',
            scorePrediction: '',
            eWallet: '',
            providerWallet: '',
            telCodeList: [],
            showName: false,
            showEmail: false,
            showPhone: false,
            showRemark: false,
            showAddress: false,
            status: '',
            formPopup: false,
            showShippingAddress: false,
            showBetID: false,
            showScorePrediction: false,
            showEWallet: false,
            showProviderWallet: false,
            showReceiptImage: false,
            receiptImagePath: '',
            disableSubmitBtn: true,
            receiptImageFileToUpload: null,
        };
    }

    async componentDidMount() {
        this.isMount = true;
        const { account } = this.props.user;
        if (account) {
            this.reset();
            this.getCountryInfo();
            this.getMainWallet();
            this.refreshAllProviderAndBalance();
            this.loadProviders(true);
            await this.initFormfield();
            this.initInfo();
            this.validateInput();
        }
        this.setState({ formPopup: this.props.formModal });
    }

    componentWillUnmount() {
        this.isMount = false;
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.toUpdate) {
            this.refreshAllProviderAndBalance();
            this.props.toUpdateProviderInfo(false);
        }

        // what is the purpose of calling function again after close the modal, temporarily comment
        // if (prevState.formPopup !== this.props.formModal) {
        //     this.setState({ formPopup: this.props.formModal });
        //     if (this.props.user.account) {
        //         this.reset();
        //         this.getCountryInfo();
        //         this.initFormfield();
        //         this.initInfo();
        //         this.getMainWallet();
        //         this.refreshAllProviderAndBalance();
        //         this.loadProviders(true);
        //     }
        // }
    }

    reset = () => {
        this.setState({ name: '', email: '', phone: '', address: '', remark: '', shippingAddress: '', betID: '', scorePrediction: '', eWallet: '', providerWallet: '' });
    };

    getCountryInfo() {
        const { user } = this.props;

        window.SPL_Content.getCountryInfo().then((telCodeList) => {
            if (this.isMount) {
                const { language } = this.props;
                let selectedObj = {};
                let phone = user.account.phone;
                if (phone && phone.length > 0) {
                    let telCode = phone.substring(0, 3);
                    selectedObj = this.getCountryCode(telCodeList, telCode);
                    if (selectedObj === null) {
                        selectedObj = this.getSelectedObj(telCodeList, language.country);
                    }
                } else {
                    selectedObj = this.getSelectedObj(telCodeList, language.country);
                }
                this.setState({
                    telCodeList: telCodeList,
                    telCode: selectedObj.telCode,
                    countryCode: selectedObj.countryCode,
                    currency: selectedObj.currency,
                });
            }
        });
    }

    getCountryCode = (telCodeList, telCode) => {
        if (telCode.length > 0) {
            let telCodeNum = telCode.split('+')[1];
            for (let i = 0; i < telCodeList.length; i++) {
                const telCodeObj = telCodeList[i];
                if (telCodeObj.telCode === telCodeNum + '') {
                    let returnObj = {
                        telCode: `+${telCodeObj.telCode}`,
                        countryCode: telCodeObj.country,
                        currency: telCodeObj.currency,
                    };
                    return returnObj;
                }
            }
            return null;
        }
        return null;
    };

    getSelectedObj(telCodeList, country) {
        let returnObj = {};
        for (let i = 0; i < telCodeList.length; i++) {
            const telCodeObj = telCodeList[i];
            if (telCodeObj.country === country) {
                returnObj = {
                    telCode: `+${telCodeObj.telCode}`,
                    countryCode: telCodeObj.country,
                    currency: telCodeObj.currency,
                };
            }
        }
        return returnObj;
    }

    initFormfield = async () => {
        const { providerWalletsList } = this.props.modalMsg;

        if (this.props.modalMsg.applyContent.formFields) {
            let resultformFieldsList = this.props.modalMsg.applyContent.formFields.split(',');
            let formFields = resultformFieldsList;
            let showName = false;
            let showEmail = false;
            let showPhone = false;
            let showRemark = false;
            let showAddress = false;
            let showShippingAddress = false;
            let showBetID = false;
            let showScorePrediction = false;
            let showEWallet = false;
            let showProviderWallet = false;
            let showReceiptImage = false;

            // input fields
            let providerWallet = null;

            for (var i = 0; i < formFields.length; i++) {
                if (formFields[i] === 'NAME') {
                    showName = true;
                } else if (formFields[i] === 'EMAIL') {
                    showEmail = true;
                } else if (formFields[i] === 'PHONE') {
                    showPhone = true;
                } else if (formFields[i] === 'REMARK') {
                    showRemark = true;
                } else if (formFields[i] === 'ADDRESS') {
                    showAddress = true;
                } else if (formFields[i] === 'SHIPPING_ADDRESS') {
                    showShippingAddress = true;
                } else if (formFields[i] === 'BET_TICKET_ID') {
                    showBetID = true;
                } else if (formFields[i] === 'SCORE_PREDICTION') {
                    showScorePrediction = true;
                } else if (formFields[i] === 'E_WALLET') {
                    showEWallet = true;
                } else if (formFields[i] === 'PROVIDER_WALLET') {
                    showProviderWallet = true;
                    if (providerWalletsList && providerWalletsList.length > 0) {
                        providerWallet = providerWalletsList[0].name;
                    }
                } else if (formFields[i] === 'IMAGE') {
                    showReceiptImage = true;
                }
            }

            this.setState({
                showName: showName,
                showEmail: showEmail,
                showPhone: showPhone,
                showRemark: showRemark,
                showAddress: showAddress,
                showShippingAddress: showShippingAddress,
                showBetID: showBetID,
                showScorePrediction: showScorePrediction,
                showEWallet: showEWallet,
                showProviderWallet: showProviderWallet,
                showReceiptImage: showReceiptImage,

                providerWallet: providerWallet,
            });
        }
    };

    initInfo = () => {
        let phone = '';
        const { account } = this.props.user;

        if (account && account.phone) {
            phone = account.phone.substring(3);
        }

        this.setState({ name: account.name, email: account.email, phone: phone });
    };

    getMainWallet = () => {
        this.setState({ iconLoading: true, restoreOnLoad: true });
        let component = this;
        return new Promise(function (resolve, reject) {
            window.SPL_Member.getMainWallet()
                .then((mainWallet) => {
                    if (component.isMount) {
                        component.setState({
                            mainWallet: mainWallet.data,
                            iconLoading: false,
                            restoreOnLoad: false,
                        });
                        component.loadProviders(true);
                        resolve(mainWallet.data);
                    }
                })
                .catch((err) => {
                    if (component.isMount) {
                        component.setState({ iconLoading: false, restoreOnLoad: false });
                    }
                });
        });
    };

    refreshAllProviderAndBalance = () => {
        this.setState({ providerList: [] });
        this.loadProviders(true);
        this.loadPromotions();
    };

    loadProviders = (isLoadAsyncProviderWallet) => {
        this.setState({ iconLoading: true });
        window.SPL_Provider.getAllProviderWalletList(null, false, this.props)
            .then((data) => {
                if (this.isMount) {
                    let providerList = data.providerList;
                    let fromProvider;
                    let toProvider;
                    const { currency } = this.props.user.account || { currency: '' };
                    const { t } = this.props;
                    for (let i = 0; i < providerList.length; i++) {
                        let balance = providerList[i].balance;
                        if (balance) {
                            balance = window.SPL_Other.formatAmount(providerList[i].balance);
                        } else {
                            balance = 0;
                        }
                        providerList[i].display = `${providerList[i].name ? providerList[i].name : 'My Wallet'} (
              ${window.SPL_Other.formatAmount(balance) || window.SPL_Other.formatAmount('0')} 
              ${currency}
            ) ${t(providerList[i].serverMaintenanceStr)}`;

                        if (providerList[i].provider === null) {
                            fromProvider = [providerList[i]];
                            toProvider = [providerList[i]];
                        }
                    }
                    this.setState({
                        providerList: data.providerList,
                        totalvalidturnoveramount: data.totalvalidturnoveramount,
                        transferAmount: window.SPL_Other.formatAmount(fromProvider[0].balance) || window.SPL_Other.formatAmount('0'),
                        fromProvider: fromProvider,
                        toProvider: toProvider,
                        iconLoading: false,
                    });
                }
            })
            .then(() => {
                if (isLoadAsyncProviderWallet) {
                    this.loadAsyncProviderWallet();
                }
            });
    };

    loadPromotions = (provider) => {
        const { countryLanguageKey } = this.props.language;
        const { portal, screen } = this.props;

        if (provider) {
            let platform = null;

            if (portal && portal.settings && portal.settings.getPromoCodeByPlatform) {
                if (window.SPL_LiteApp.isZT828LiteApp()) {
                    platform = 'A';
                } else if (screen.viewType === 'web') {
                    platform = 'W';
                } else {
                    platform = 'M';
                }
            }

            window.SPL_Provider.loadPromotions(provider, null, countryLanguageKey, platform).then((promoCodeList) => {
                if (this.isMount) {
                    promoCodeList.unshift(this.defaultPromo);
                    this.setState({
                        promoCodeList: promoCodeList,
                        selectedPromotionCode: [promoCodeList[0]],
                    });
                }
            });
        } else {
            let promoCodeList = [];
            promoCodeList.unshift(this.defaultPromo);
            if (this.isMount) {
                this.setState({
                    promoCodeList: promoCodeList,
                    selectedPromotionCode: [promoCodeList[0]],
                });
            }
        }
    };

    loadAsyncProviderWallet = () => {
        if (this.isMount) {
            this.setState({ isLoad: true }, () => {
                window.SPL_Provider.loadAsyncProviderWallet(null, this.props).then((providerWallet) => {
                    let providerList = this.state.providerList;
                    for (let i = 0; i < providerList.length; i++) {
                        let results = providerWallet.providerList.filter(function (e) {
                            return e.provider === providerList[i].provider;
                        })[0];

                        if (results) {
                            providerList[i].balance = results.balance ? results.balance : 0;
                            providerList[i].serverIsUnderMaintenance = results.serverIsUnderMaintenance;
                            providerList[i].isdisplay = true;
                            providerList[i].serverMaintenanceStr = results.serverIsUnderMaintenance ? 'error:error.underMaintainance' : '';
                        } else {
                            providerList[i].serverMaintenanceStr = '';
                        }
                        if (this.isMount) {
                            this.setState({ providerList: providerList });
                        }
                    }
                });
            });
        }
    };

    handleNameChange = (e) => {
        this.setState({ name: e.target.value });
    };

    selectCode = (countryCode) => {
        let selectedObj = this.getSelectedObj(this.state.telCodeList, countryCode);
        this.setState({ telCode: selectedObj.telCode, countryCode: selectedObj.countryCode, currency: selectedObj.currency });
    };

    handleSubmit = () => {
        const { user } = this.props;
        const { applyContent } = this.props.modalMsg;
        const {
            name,
            showName,
            phone,
            showPhone,
            email,
            showEmail,
            address,
            showAddress,
            shippingAddress,
            showShippingAddress,
            betID,
            showBetID,
            scorePrediction,
            showScorePrediction,
            eWallet,
            showEWallet,
            providerWallet,
            showProviderWallet,
            receiptImageFileToUpload,
        } = this.state;

        if (
            (name === '' && showName) ||
            (phone === '' && showPhone) ||
            (email === '' && showEmail) ||
            (address === '' && showAddress) ||
            (shippingAddress === '' && showShippingAddress) ||
            (betID === '' && showBetID) ||
            (scorePrediction === '' && showScorePrediction) ||
            (eWallet === '' && showEWallet) ||
            (providerWallet === '' && showProviderWallet)
        ) {
            notification.showNotification('error', 'Please complete information in the form');
            return;
        }

        let date = new Date();
        let optionalFields = {
            shippingAddress: shippingAddress,
            betTicketId: betID,
            scorePrediction: scorePrediction,
            eWallet: eWallet,
            providerWallet: providerWallet,
        };
        let params = {
            createdDate: date,
            status: 'P',
            memberId: user.account.id,
            promotionId: applyContent.id,
            phone: this.state.telCode + this.state.phone,
            name: name,
            remark: this.state.remark,
            address: address,
            email: email,
            language: applyContent.language,
            optionalFieldsJson: JSON.stringify(optionalFields),
            receiptImagePath: applyContent.image,
            receiptImageFileToUpload,
        };
        window.SPL_Member.applyPromotion(params).then((data) => {
            if (this.isMount) {
                if (data.success) {
                    this.setState(
                        {
                            status: 'S',
                            message: 'promotion:promotion.successMsg',
                            name: '',
                            email: '',
                            phone: '',
                            address: '',
                            remark: '',
                        },
                        () => {
                            setTimeout(() => {
                                this.setState({ status: '', formPopup: false });
                            }, 5000);
                        }
                    );
                } else {
                    if (data.errorTranslate === 'promotion:promotion.exceeditLimit') {
                        this.setState({ status: 'F', message: `promotion:promotion.exceeditLimit` });
                    } else {
                        this.setState({ status: 'F', message: `transaction:transaction.deposit.${data.errorKey}` });
                    }
                }
            }
        });
    };

    handleLoginModalOk = () => {
        this.setState({ loginModalVisible: false });
    };

    validateInput = () => {
        const {
            name,
            showName,
            phone,
            showPhone,
            email,
            showEmail,
            address,
            showAddress,
            shippingAddress,
            showShippingAddress,
            betID,
            showBetID,
            scorePrediction,
            showScorePrediction,
            eWallet,
            showEWallet,
            providerWallet,
            showProviderWallet,
            showReceiptImage,
            receiptImageFileToUpload,
            receiptImagePath,
        } = this.state;

        let enableSubmitButton = true;

        if (!name && showName) {
            enableSubmitButton = enableSubmitButton && false;
        }

        if (!phone && showPhone) {
            enableSubmitButton = enableSubmitButton && false;
        }

        if (!email && showEmail) {
            enableSubmitButton = enableSubmitButton && false;
        }

        if (!address && showAddress) {
            enableSubmitButton = enableSubmitButton && false;
        }

        if (!shippingAddress && showShippingAddress) {
            enableSubmitButton = enableSubmitButton && false;
        }

        if (!betID && showBetID) {
            enableSubmitButton = enableSubmitButton && false;
        }

        if (!scorePrediction && showScorePrediction) {
            enableSubmitButton = enableSubmitButton && false;
        }

        if (!eWallet && showEWallet) {
            enableSubmitButton = enableSubmitButton && false;
        }
        if (!providerWallet && showProviderWallet) {
            enableSubmitButton = enableSubmitButton && false;
        }
        if ((!receiptImagePath || !receiptImageFileToUpload) && showReceiptImage) {
            enableSubmitButton = enableSubmitButton && false;
        }

        this.setState({ disableSubmitBtn: !enableSubmitButton });
    };

    handleNameChange = (e) => {
        const newValue = e.target.value;
        this.setState({ name: newValue }, () => this.validateInput());
    };
    handlePhoneChange = (e) => {
        if (this.isNumber(e)) {
            const newValue = e.target.value;
            this.setState({ phone: newValue }, () => this.validateInput());
        }
    };
    handleEmailChange = (e) => {
        const newValue = e.target.value;
        this.setState({ email: newValue }, () => this.validateInput());
    };
    handleAddressChange = (e) => {
        const newValue = e.target.value;
        this.setState({ address: newValue }, () => this.validateInput());
    };
    // remarks no need validateion
    handleRemarkChange = (e) => {
        const newValue = e.target.value;
        this.setState({ remark: newValue });
    };
    handleShippingAddressChange = (e) => {
        const newValue = e.target.value;
        this.setState({ shippingAddress: newValue }, () => this.validateInput());
    };
    handleBetIdChange = (e) => {
        const newValue = e.target.value;
        this.setState({ betID: newValue }, () => this.validateInput());
    };
    handleScoreChange = (e) => {
        const newValue = e.target.value;
        this.setState({ scorePrediction: newValue }, () => this.validateInput());
    };
    handleEWalletChange = (e) => {
        const newValue = e.target.value;
        this.setState({ eWallet: newValue }, () => this.validateInput());
    };
    handleProviderWalletChange = (e) => {
        const newValue = e.target.value;
        this.setState({ providerWallet: newValue }, () => this.validateInput());
    };
    handleUploadImageChange = (e) => {
        const accept = this.props.portal.settings?.features?.promotionSettings?.uploadImageType;
        const uploadImageType = e.target.files[0]?.type;

        if (accept?.length && !accept.some((type) => uploadImageType.includes(type))) {
            // promoApplyInput['receiptImageFileToUpload'] = null;
            const errorKey = 'receiptInvalid';
            const message = `transaction:transaction.deposit.${errorKey}`;
            this.setState(
                {
                    message: message,
                    receiptImagePath: '',
                    status: 'F',
                    receiptImageFileToUpload: null,
                },
                () => this.validateInput()
            );
        } else {
            // promoApplyInput[field] = e.target.files[0];
            this.setState({ receiptImagePath: e.target.value, status: '', message: '', receiptImageFileToUpload: e.target.files[0] }, () => this.validateInput());
        }
    };
    isNumber = (event) => {
        return /^\d*$/.test(event.target.value);
    };

    render() {
        const { applyContent, toggleFormModal, providerWalletsList } = this.props.modalMsg;
        const { disableSubmitBtn } = this.state;

        return (
            <Translation>
                {(t) =>
                    this.state.formPopup && (
                        <div className='messaging-popup form-popup'>
                            <div className='popup'>
                                <div className='popup-header'>
                                    <div className='popup-header-left'>
                                        <div className='popup-title'>
                                            <p>{t('promotion:promotion.fillup-detail', 'Please fill up the detail')}</p>
                                            <p>{t(applyContent.title)}</p>
                                        </div>
                                    </div>
                                    <div className='popup-header-right'>
                                        <SVGElements name='close-icon' onClick={toggleFormModal} />
                                        {/* <MdClose onClick={toggleFormModal} /> */}
                                    </div>
                                </div>
                                <div className='popup-body'>
                                    {this.state.showName && (
                                        <div className='name-popup'>
                                            <p>{t('global:global.form.fullname')}</p>
                                            <div className='popup-field'>
                                                <input
                                                    name='fullname'
                                                    className={`form-control-inner`}
                                                    id='name'
                                                    placeholder='Full Name'
                                                    value={this.state.name}
                                                    type='text'
                                                    onChange={this.handleNameChange}
                                                    disabled
                                                />
                                                <p className='text-red'>{this.state.fullnameError}</p>
                                            </div>
                                        </div>
                                    )}

                                    {this.state.showPhone && (
                                        <div className='num-popup'>
                                            <p>{t('global:global.form.phone')}</p>
                                            <div className='popup-field'>
                                                <FlagsSelect
                                                    telCodeList={this.state.telCodeList}
                                                    onSelect={this.selectCode}
                                                    countryCode={this.state.countryCode}
                                                    disabled={true}
                                                />
                                                <input
                                                    name='mobile'
                                                    className={`popup-phone`}
                                                    id='mobile'
                                                    placeholder='Enter mobile'
                                                    value={this.state.phone}
                                                    onChange={this.handlePhoneChange}
                                                    disabled
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {this.state.showEmail && (
                                        <div className='email-popup'>
                                            <p>{t('global:global.form.email')}</p>
                                            <div className='popup-field'>
                                                <input
                                                    name='email'
                                                    className={`form-control-inner`}
                                                    id='email'
                                                    placeholder='Enter email'
                                                    value={this.state.email}
                                                    onChange={this.handleEmailChange}
                                                    disabled
                                                />
                                                <p className='text-red'>{this.state.emailError}</p>
                                            </div>
                                        </div>
                                    )}

                                    {this.state.showBetID && (
                                        <div className='betId-popup'>
                                            <p>{t('global:global.form.betId')}</p>
                                            <div className='popup-field'>
                                                <input
                                                    name='betId'
                                                    className={`form-control-inner`}
                                                    id='betId'
                                                    placeholder={t('global:global.form.betId')}
                                                    value={this.state.betID}
                                                    onChange={this.handleBetIdChange}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {this.state.showScorePrediction && (
                                        <div className='score-popup'>
                                            <p>{t('global:global.form.scorePrediction')}</p>
                                            <div className='popup-field'>
                                                <input
                                                    name='scorePrediction'
                                                    className={`form-control-inner`}
                                                    id='scorePrediction'
                                                    placeholder={t('global:global.form.scorePrediction')}
                                                    value={this.state.scorePrediction}
                                                    onChange={this.handleScoreChange}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {this.state.showEWallet && (
                                        <div className='eWallet-popup'>
                                            <p>{t('global:global.form.eWallet')}</p>
                                            <div className='popup-field'>
                                                <input
                                                    name='eWallet'
                                                    className={`form-control-inner`}
                                                    id='eWallet'
                                                    placeholder={t('global:global.form.eWallet')}
                                                    value={this.state.eWallet}
                                                    onChange={this.handleEWalletChange}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {this.state.showProviderWallet && (
                                        <div className='providerWallet-popup'>
                                            <p>{t('global:global.form.providerWallet')}</p>
                                            <div className='popup-field'>
                                                <select value={this.state.providerWallet} onChange={this.handleProviderWalletChange}>
                                                    {(providerWalletsList || []).map((provider, i) => (
                                                        <option key={i} value={provider.name}>
                                                            {provider.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    )}

                                    {this.state.showAddress && (
                                        <div className='address-popup'>
                                            <p>{t('global:global.form.address')}</p>
                                            <div className='popup-field'>
                                                <textarea
                                                    className='text-area'
                                                    value={this.state.address}
                                                    rows='5'
                                                    name='address'
                                                    placeholder='Address'
                                                    onChange={this.handleAddressChange}
                                                />
                                                <p className='text-red'>{this.state.addressError}</p>
                                            </div>
                                        </div>
                                    )}

                                    {this.state.showRemark && (
                                        <div className='remark-popup'>
                                            <p>{t('global:global.form.remark')}</p>
                                            <div className='popup-field'>
                                                <textarea
                                                    className='text-area'
                                                    value={this.state.remark}
                                                    rows='5'
                                                    name='remark'
                                                    placeholder='Remark'
                                                    onChange={this.handleRemarkChange}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {this.state.showShippingAddress && (
                                        <div className='shippingAddress-popup'>
                                            <p>{t('global:global.form.shippingAddress')}</p>
                                            <div className='popup-field'>
                                                <textarea
                                                    className='form-control-inner'
                                                    value={this.state.shippingAddress}
                                                    rows='5'
                                                    name='shippingAddress'
                                                    placeholder={t('global:global.form.shippingAddress')}
                                                    onChange={this.handleShippingAddressChange}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {this.state.showReceiptImage && (
                                        <div className='shippingAddress-popup'>
                                            <p>{t('global:global.form.uploadImage', 'Upload Image')}</p>
                                            <div className='popup-field'>
                                                <UploadImage
                                                    accept={this.props.portal.settings?.features?.promotionSettings?.uploadImageType || []}
                                                    value={this.state.receiptImagePath}
                                                    onChange={this.handleUploadImageChange}
                                                >
                                                    {(file, imagePath) => (
                                                        <div className='uploadWrapper'>
                                                            {!imagePath && (
                                                                <>
                                                                    <div className='uploadInput'>
                                                                        <input
                                                                            readOnly
                                                                            placeholder='Enter mobile'
                                                                            value={t('global:global.form.selectImage', 'Select image')}
                                                                        />
                                                                    </div>
                                                                    <button className='uploadButton'>{t('global:global.form.upload', 'Upload')}</button>
                                                                </>
                                                            )}
                                                            {imagePath && <img width='100%' src={imagePath} alt={file?.name || 'receipt image'} />}
                                                        </div>
                                                    )}
                                                </UploadImage>
                                            </div>
                                        </div>
                                    )}

                                    {this.state.status === 'F' && (
                                        <div className='invalid-feedback text-danger'>
                                            <Trans i18nKey={this.state.message}></Trans>
                                        </div>
                                    )}
                                    {this.state.status === 'S' && (
                                        <div className='invalid-feedback text-success success-popup'>
                                            <div className='success-popup-body'>
                                                <SVGElements name='close-icon' onClick={() => this.setState({ status: '', formPopup: false })} />
                                                {/* <MdClose onClick={() => this.setState({ status: '', formPopup: false })} /> */}
                                                <Trans className='success-popup-msg' i18nKey={this.state.message}></Trans>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                <div className='popup-footer'>
                                    <button disabled={disableSubmitBtn} onClick={this.handleSubmit} className='btn-normal btn-submit-popup'>
                                        {t('transaction:transaction.deposit.localPay.submit', 'Submit')}
                                    </button>
                                </div>
                            </div>
                            <div className='popup-overlay' onClick={toggleFormModal}></div>
                        </div>
                    )
                }
            </Translation>
        );
    }
}

export default connect(mapStateToProps)(withTranslation()(withRouter(FormPopUp)));
